import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { UserFragment, ArtworkFragment, CollectionFragment } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionSalesHistoryVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
  limit: Types.Scalars['Int'];
  offset: Types.Scalars['Int'];
}>;


export type CollectionSalesHistory = { items: Array<(
    Pick<Types.Collection_Sales_History, 'tokenId' | 'dateSold' | 'eventType' | 'name' | 'priceLastSoldFor'>
    & { buyer: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, seller: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, artwork: Types.Maybe<(
      Pick<Types.Artwork, 'id' | 'name' | 'chainId' | 'description' | 'assetScheme' | 'assetHost' | 'assetPath' | 'assetIPFSPath' | 'metadataScheme' | 'metadataHost' | 'metadataPath' | 'metadataIPFSPath' | 'duration' | 'mimeType' | 'mintTxHash' | 'assetId' | 'assetStatus' | 'tokenId' | 'status' | 'hiddenAt' | 'deletedAt' | 'moderationStatus' | 'moderationFrom' | 'latestTxDate' | 'assetVersion' | 'ownerPublicKey' | 'publicKey' | 'contractAddress' | 'activeSalePriceInETH' | 'lastSalePriceInETH' | 'isIndexed'>
      & { collection: Types.Maybe<Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>>, creator: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>> }
    )> }
  )> };



export const CollectionSalesHistoryDocument = /*#__PURE__*/ `
    query CollectionSalesHistory($contractAddress: String!, $limit: Int!, $offset: Int!) {
  items: collection_sales_history(
    where: {contractAddress: {_eq: $contractAddress}}
    order_by: {dateSold: desc}
    limit: $limit
    offset: $offset
  ) {
    tokenId
    dateSold
    eventType
    name
    priceLastSoldFor
    buyer {
      ...UserFragment
    }
    seller {
      ...UserFragment
    }
    artwork {
      ...ArtworkFragment
      collection {
        ...CollectionFragment
      }
      creator: user {
        ...UserFragment
      }
    }
  }
}
    ${UserFragment}
${ArtworkFragment}
${CollectionFragment}`;

export const useCollectionSalesHistory = <
      TData = CollectionSalesHistory,
      TError = ClientError
    >(
      variables: CollectionSalesHistoryVariables,
      options?: Omit<UseQueryOptions<CollectionSalesHistory, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionSalesHistory, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionSalesHistory, TError, TData>(
      {
    queryKey: ['CollectionSalesHistory', variables],
    queryFn: hasuraFetcher<CollectionSalesHistory, CollectionSalesHistoryVariables>(CollectionSalesHistoryDocument, variables),
    ...options
  }
    )};

useCollectionSalesHistory.getKey = (variables: CollectionSalesHistoryVariables) => ['CollectionSalesHistory', variables];

export const useInfiniteCollectionSalesHistory = <
      TData = InfiniteData<CollectionSalesHistory>,
      TError = ClientError
    >(
      variables: CollectionSalesHistoryVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionSalesHistory, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionSalesHistory, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionSalesHistory, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionSalesHistory.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionSalesHistory, CollectionSalesHistoryVariables>(CollectionSalesHistoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionSalesHistory.getKey = (variables: CollectionSalesHistoryVariables) => ['CollectionSalesHistory.infinite', variables];


useCollectionSalesHistory.fetcher = (variables: CollectionSalesHistoryVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionSalesHistory, CollectionSalesHistoryVariables>(CollectionSalesHistoryDocument, variables, options);
